export default __webpack_public_path__ + "static/media/LAS0870.34I-39519_-23420_0.6cad4239.jpg";